import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import useBusinessStatus from '../BusinessStatus';

const TopBar = ({
  officeEmail,
  facebookLink,
  whatsappLink,
  wechatLink,
  callLink,
}) => {
  const { t } = useTranslation();
  const { currentTime, status } = useBusinessStatus();
  const statusClass = status === t('open') ? 'status-open' : 'status-closed';

  return (
    <div className="top_bar" id="top-bar">
      <div className="container">
        <div className="top_bar_inner">
          <div className="header_social">
            <ul className="top_social">
              <li className="Call">
                <a href={`tel:${callLink}`} aria-label="Call">
                  <i className="ionicons ion-android-call" />
                </a>
              </li>
              <li className="WhatSapp">
                <a
                  href={whatsappLink}
                  target="_blank"
                  rel="noreferrer"
                  aria-label="WhatsApp"
                >
                  <i className="ionicons ion-social-whatsapp-outline" />
                </a>
              </li>
              <li className="dribbble">
                <a
                  href={wechatLink}
                  target="_blank"
                  rel="noreferrer"
                  aria-label="WeChat"
                >
                  <i className="ionicons ion-chatbubbles" />
                </a>
              </li>
              <li className="facebook">
                <a
                  href={facebookLink}
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Facebook"
                >
                  <i className="ion-social-facebook" />
                </a>
              </li>
            </ul>
            <h6>{t('FollowUs')}</h6>
          </div>

          <div className="header_info">
            <div className="schedule tps-navbar__schedule">
              <div
                className="hide_icon d-md-none"
                data-text={`${t('MondayFriday')}(8.30am - 5.30pm)`}
              >
                <span>
                  <i className="fa fa-clock-o" />
                </span>
              </div>
              <div className="d-none d-md-block">
                <span>
                  <i className="fa fa-clock-o" />
                </span>{' '}
                {t('MondayFriday')}
                <strong>
                  (8.30am - 5.30pm) {currentTime.toLocaleTimeString()} {t('status')}:{' '}
                  <span className={statusClass}>{status}</span>
                </strong>
              </div>
            </div>

            <div className="schedule tps-navbar__email">
              <div className="hide_icon d-md-none" data-text={officeEmail}>
                <span>
                  <i className="fa fa-envelope" />
                </span>
              </div>
              <div className="d-none d-md-block">
                <span>
                  <i className="fa fa-envelope" />
                </span>{' '}
                {officeEmail}
              </div>
            </div>

            <div className="free_contact">
              <Link to="/contact" className="btn">
                {t('RequestQuote')}
              </Link>
            </div>

            <a
              href="https://admin.tps-lao.com/"
              target="_blank"
              rel="noreferrer"
              className="login tps-navbar__login"
            >
              {t('Login')}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
